"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontPageTitle = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
require("./index.scss");
const className = 'front-page-title';
class FrontPageTitle extends react_1.default.PureComponent {
    render() {
        const { text, modificators } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("h1", null, text))));
    }
}
exports.FrontPageTitle = FrontPageTitle;
FrontPageTitle.defaultProps = {
    text: null,
};
//# sourceMappingURL=index.js.map